
import { useAchievements } from "@/hooks/use-achievements";
import { AchievementBadge } from "@/components/ui/achievement-badge";
import { AchievementNotification } from "@/components/ui/achievement-notification";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronsUpDown } from "lucide-react";

export function AchievementsSection() {
  const { achievements, newlyUnlocked, dismissNewAchievements } =
    useAchievements();

  const unlockedCount = achievements.filter((a) => a.unlocked).length;
  const totalCount = achievements.length;
  const allUnlocked = totalCount > 0 && unlockedCount === totalCount;

  const achievementsGrid = (
    <div className="grid grid-cols-1 gap-2 sm:gap-3">
      {achievements.map((achievement) => (
        <AchievementBadge
          key={achievement.id}
          achievement={achievement}
          size="sm"
        />
      ))}
    </div>
  );

  return (
    <>
      <section className="bg-white rounded-lg shadow-sm p-4 md:p-6">
        {allUnlocked ? (
          <Collapsible defaultOpen={false}>
            <div className="flex items-center justify-between mb-4">
              <CollapsibleTrigger className="flex items-center gap-2 text-lg font-semibold text-gray-900 hover:text-gray-700">
                Achievements
                <ChevronsUpDown className="h-4 w-4 shrink-0 text-gray-500" />
              </CollapsibleTrigger>
              <div className="text-sm text-gray-600">
                {unlockedCount} of {totalCount}
              </div>
            </div>
            <CollapsibleContent>{achievementsGrid}</CollapsibleContent>
          </Collapsible>
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900">
                Achievements
              </h2>
              <div className="text-sm text-gray-600">
                {unlockedCount} of {totalCount}
              </div>
            </div>
            {achievementsGrid}
          </>
        )}
      </section>

      <AchievementNotification
        achievements={newlyUnlocked}
        onDismiss={dismissNewAchievements}
      />
    </>
  );
}
